<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span> <em name="Exhibition"></em> <span>/</span>參展產品
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div>
        <div class="message-alert">
          <div
            class="alertM alert-dismissible animate__animated animate__fadeInRight animate__fast"
            :class="'alert-' + item.status"
            v-for="(item, i) in messages"
            :key="i"
          >
            <span class="mr-2">
              <i class="fas fa-bell"></i>
            </span>
            {{ item.message }}
          </div>
        </div>

        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="PcDevice">
          <div class="contentBoxStatus">
            <p class="mb-2 text-center" style="font-size: 15px">
              為確保參觀者能清楚了解您的公司、產品及服務內容，請務必完成下列各個項目的資料上傳
            </p>

            <div
              class="mb-4 border text-center py-2"
              style="font-size: 15px; margin-right: 17%; margin-left: 17%; border-radius: 30px"
            >
              <div class="d-flex justify-content-around">
                <a :href="`profile?no=${RegNo}`">
                  <div class="d-flex align-items-center">
                    <span v-if="BasicinformationStatus == 1" class="complete mr-1"></span>
                    <span v-else class="uncomplete mr-1"></span>
                    <span style="color: black">基本資料 </span>
                  </div>
                </a>

                <a :href="`product?no=${RegNo}`">
                  <div class="d-flex align-items-center">
                    <span v-if="ProductStatus !== 0" class="complete mr-1"></span>
                    <span v-else class="uncomplete mr-1"></span>
                    <span class="border-dark text-dark">參展產品 </span>
                  </div>
                </a>

                <a :href="`news?no=${RegNo}`">
                  <div class="d-flex align-items-center">
                    <span v-if="PressReleaseStatus !== 0" class="complete mr-1"></span>
                    <span v-else class="uncomplete mr-1"></span>

                    <span style="color: black">新聞稿 </span>
                  </div>
                </a>

                <a :href="`video?no=${RegNo}`">
                  <div class="d-flex align-items-center">
                    <span v-if="VideoStatus !== 0" class="complete mr-1"></span>
                    <span v-else class="uncomplete mr-1"></span>

                    <span style="color: black">參展商影音 </span>
                  </div>
                </a>
                <span v-if="showOnlineStatus">
                  <a :href="`onlineExpo?no=${RegNo}`">
                    <div class="d-flex align-items-center">
                      <span v-if="OnlineExpolayoutStatus == 1" class="complete mr-1"></span>
                      <span v-else class="uncomplete mr-1"></span>
                      <span style="color: black">線上展覽設定 </span>
                    </div>
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>

        <div class="contentBox">
          <div id="SliderTop">
            <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
          </div>

          <div class="MbDevice">
            <p class="mb-2 text-center" style="font-size: 12px">
              為確保參觀者能清楚了解您的公司、產品及服務內容，請務必完成下列各個項目的資料上傳
            </p>

            <div class="mb-4 border text-center py-2" style="font-size: 12px; border-radius: 10px">
              <div class="d-flex justify-content-around">
                <div>
                  <a :href="`profile?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="BasicinformationStatus == 1" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <span style="color: black">基本資料 </span>
                    </div>
                  </a>
                </div>
                <div>
                  <a :href="`product?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="ProductStatus !== 0" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                      <div class="col-md-6">
                        <span class="border-dark text-dark">參展產品 </span>
                      </div>
                    </div>
                  </a>
                </div>
                <div>
                  <a :href="`news?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="PressReleaseStatus !== 0" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                      <div class="col-md-6">
                        <span style="color: black">新聞稿 </span>
                      </div>
                    </div>
                  </a>
                </div>
                <div>
                  <a :href="`video?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="VideoStatus !== 0" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                      <div class="col-md-6">
                        <span style="color: black">參展商影音 </span>
                      </div>
                    </div>
                  </a>
                </div>

                <div v-if="showOnlineStatus">
                  <a :href="`onlineExpo?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="OnlineExpolayoutStatus == 1" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                      <div class="col-md-6">
                        <span style="color: black">線上展覽設定 </span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div>
              <h1>參展產品</h1>
            </div>
          </div>

          <p class="my-3">&nbsp;</p>
          <p class="alert">
            您已經建立 <span class="red" name="existProd">{{ totalNo }}</span> 個產品，還可以建立
            <span class="red" name="leftAmount">{{ ProductAmount - totalNo }}</span> 個產品，依最後更新時間排序
          </p>
          <p class="my-3">&nbsp;</p>

          <div class="PcDevice_inline">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div>
                <span class="btn btn-lg btn-primary text-nowrap mr-2" @click.prevent="toProductAdd">新增產品</span>
                <span
                  v-if="hasHistoryPro"
                  class="btn btn-lg btn-outline-primary mr-2 text-nowrap"
                  @click.prevent="toHistoryExhibitors"
                  >複製歷屆產品
                </span>
                <span>需要建立更多參展產品嗎？請參考<a :href="`upgrade?no=${RegNo}`" class=" ">加值服務方案</a>。</span>
              </div>
            </div>
          </div>

          <div class="MbDevice">
            <div class="d-flex align-items-center mb-2">
              <div class="btn btn-lg btn-primary text-nowrap mr-2" @click.prevent="toProductAdd">新增產品</div>
              <div>需要建立更多參展產品嗎？請參考<a :href="`upgrade?no=${RegNo}`">加值服務方案</a>。</div>
            </div>

            <hr />

            <span
              v-if="hasHistoryPro"
              class="btn btn-outline-primary text-nowrap mr-2"
              @click.prevent="toHistoryExhibitors"
              >複製歷屆產品
            </span>
          </div>

          <div class="PcDevice">
            <p class="my-3">&nbsp;</p>

            <ul id="product" v-for="item in ProductList">
              <li>
                <div class="d-flex justify-content-between align-items-center mx-1">
                  <div>
                    <div class="d-flex ml-3 align-items-center">
                      <div class="mt-4 d-flex align-items-center">
                        <span class="text-center pt-1 mr-3 NumberStyle">
                          {{ item.No }}
                        </span>
                        <img
                          :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`"
                          class="img-fluid"
                          width="200px"
                        />
                      </div>

                      <div class="ml-4">
                        <p
                          class="formTitle mb-2"
                          style="word-break: break-all; width: 500px"
                          v-if="item.ProName !== 'N/A'"
                        >
                          {{ item.ProName }}
                        </p>
                        <p class="formTitle mb-2" v-if="item.ProName == 'N/A'">
                          <span class="text-danger">N/A (未設定)</span>
                        </p>

                        <p class="gray" v-if="item.CatName !== 'N/A'">類別：{{ item.CatName }}</p>
                        <p class="gray" v-if="item.CatName == 'N/A'">類別：<span class="text-danger">未設定</span></p>

                        <div class="gray d-flex align-items-center">
                          <div>官網狀態：</div>

                          <div
                            class="pointer d-flex align-items-center"
                            @click="switchButtom(item.ProNo, item.Archived, item.ProName)"
                            v-if="item.Archived == 1"
                          >
                            <div>
                              <img src="@/assets/images/off-button.png" width="28px" />
                            </div>
                            <div class="ml-1">隱藏</div>
                          </div>

                          <div
                            class="pointer d-flex align-items-center"
                            @click="switchButtom(item.ProNo, item.Archived)"
                            v-else
                          >
                            <img src="@/assets/images/on-button.png" width="28px" />
                            <span class="ml-1">顯示</span>
                          </div>
                        </div>
                        <p class="gray">
                          前台：

                          <span v-if="item.Archived == 1">
                            <i class="fas fa-eye mr-2"></i>
                            <span style="color: #1a73e8" class="Preview-style" @click="ProductModal(item.ProNo)"
                              >預覽頁面
                            </span>
                          </span>
                          <span v-else>
                            <i class="fas fa-eye mr-2"></i>
                            <a :href="item.ExhWebsiteProductUrl" target="_blank">頁面快速連結</a>
                          </span>
                        </p>
                        <p class="gray">更新：{{ item.UpdateTime }}</p>
                        <div class="gray" v-if="totalNo > 1">
                          排序：<span style="color: #1a73e8" class="pointer" @click.prevent="openProNo">調整</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-right mt-3">
                    <div class="PcDevice mr-5">
                      <div class="btn btn-lg btn-primary text-nowrap" @click.prevent="toEditProduct(item.ProNo)">
                        修改
                      </div>

                      <div class="btn btn-lg btn-secondary text-nowrap ml-2" @click.prevent="delProduct(item.ProNo)">
                        刪除
                      </div>
                    </div>
                    <div class="MbDevice">
                      <div class="btn btn-sm btn-primary text-nowrap" @click.prevent="toEditProduct(item.ProNo)">
                        修改
                      </div>

                      <div class="btn btn-sm btn-secondary text-nowrap ml-2" @click.prevent="delProduct(item.ProNo)">
                        刪除
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <hr />
            </ul>

            <!-- PC版分頁 -->

            <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
              <nav>
                <ul class="pagination">
                  <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                    <a class="page-link" href="#" title="切換前十頁" aria-label="Previous" @click="returntenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                    </a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <a class="page-link" href="#" title="上一頁" aria-label="Previous" @click="lastPage()">
                      <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                    </a>
                  </li>
                  <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                    <a class="page-link" href="#" @click="getPage(page)">{{ page }}</a>
                  </li>

                  <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                    <a class="page-link" href="#" title="下一頁" aria-label="Next" @click="nextPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                    </a>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <a class="page-link" href="#" title="切換下十頁" aria-label="Next" @click="nexttenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                    </a>
                  </li>
                </ul>
                <p class="text-center mt-2">第 {{ currentPage }} / {{ totalPage }} 頁</p>
              </nav>
            </div>
          </div>

          <!-- Mb版 -->

          <div class="MbDevice">
            <div class="col-lg-10 text-dark">
              <div class="row">
                <div class="col-sm-6 mb-2" v-for="(item, index) in ProductList" :key="index">
                  <div class="card mt-4">
                    <div class="card-body">
                      <div class="imgstyle text-center">
                        <div class="text-center">
                          <div class="ml-2 pt-1 NumberStyle mb-2">{{ item.No }}</div>
                        </div>
                        <img
                          :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`"
                          class="img-fluid"
                        />
                      </div>
                      <ul class="list-group list-group-flush mx-2">
                        <div class="mt-3 mb-1" style="font-size: 15px">
                          <strong>{{ item.ProName }}</strong>
                        </div>
                        <p class="gray">類別：{{ item.CatName }}</p>

                        <div class="gray d-flex align-items-center">
                          <div>官網狀態：</div>
                          <div
                            class="pointer d-flex align-items-center"
                            @click="switchButtom(item.ProNo, item.Archived, item.ProName)"
                            v-if="item.Archived == 1"
                          >
                            <div>
                              <img src="@/assets/images/off-button.png" width="28px" />
                            </div>
                            <div class="ml-1">隱藏</div>
                          </div>

                          <div
                            class="pointer d-flex align-items-center"
                            @click="switchButtom(item.ProNo, item.Archived)"
                            v-else
                          >
                            <img src="@/assets/images/on-button.png" width="28px" />
                            <span class="ml-1">顯示</span>
                          </div>
                        </div>
                        <p class="gray">
                          前台：
                          <span v-if="item.Archived == 1">
                            <i class="fas fa-eye mr-1"></i>
                            <span style="color: #1a73e8" class="Preview-style" @click="ProductModal(item.ProNo)"
                              >預覽頁面
                            </span>
                          </span>
                          <span v-else>
                            <i class="fas fa-eye mr-1"></i>
                            <a :href="item.ExhWebsiteProductUrl" target="_blank">頁面快速連結</a>
                          </span>
                        </p>
                        <p class="gray">更新：{{ item.UpdateTime }}</p>
                        <div class="gray mb-2" v-if="totalNo > 1">
                          排序：<span style="color: #1a73e8" class="pointer" @click.prevent="openProNo">調整</span>
                        </div>
                        <div class="card-footer">
                          <div class="d-flex justify-content-between align-items-center mt-2">
                            <div>
                              官網狀態 :
                              <span class="text-danger text-nowrap" v-if="item.Archived === 1">隱藏</span>
                              <span v-else class="text-success text-nowrap">顯示</span>
                            </div>
                            <div>
                              <div class="btn btn-sm btn-primary" @click.prevent="toEditProduct(item.ProNo)">修改</div>
                              <div
                                class="btn btn-sm btn-secondary btn-primary ml-1"
                                @click.prevent="delProduct(item.ProNo)"
                              >
                                刪除
                              </div>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
              <nav>
                <ul class="pagination pagination-sm">
                  <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                    <a class="page-link" href="#" title="切換前十頁" aria-label="Previous" @click="returntenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                    </a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <a class="page-link" href="#" title="上一頁" aria-label="Previous" @click="lastPage()">
                      <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                    </a>
                  </li>
                  <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                    <a class="page-link" href="#" @click="getPage(page)">{{ page }}</a>
                  </li>

                  <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                    <a class="page-link" href="#" title="下一頁" aria-label="Next" @click="nextPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                    </a>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <a class="page-link" href="#" title="切換下十頁" aria-label="Next" @click="nexttenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                    </a>
                  </li>
                </ul>
                <p class="text-center mt-2">第 {{ currentPage }} / {{ totalPage }} 頁</p>
              </nav>
            </div>
          </div>

          <!-- Modal -->
          <!-- Modal 新聞稿彈跳模組-->
          <div
            class="modal fade"
            id="openProNoModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="ModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <div class="PcDevice">
                    <div class="modal-title h3" id="ModalLabel"><i class="fas fa-sort mr-1"></i> 產品排序</div>
                  </div>
                  <div class="MbDevice">
                    <div class="modal-title h5" id="ModalLabel">
                      <i class="fas fa-sort mr-1"></i>
                      產品排序
                    </div>
                  </div>
                  <button type="button" class="close" aria-label="Close" @click.prevent="CloseProNoModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body my-2">
                  <div class="mb-3">
                    <div>*請 <span style="text-decoration: underline">手動拖拉產品名稱</span> 以調整產品排序。</div>
                    <div>*調整產品排序後，請按下「儲存」按鈕才算完成修改。</div>
                  </div>

                  <hr />

                  <div class="Pro_draggable mb-1 font-weight-bold">
                    <div class="index-item mb-1">序號</div>
                    <div class="mb-1" style="padding: 0 5px">產品名稱</div>
                  </div>
                  <div class="Pro_draggable">
                    <div>
                      <div v-for="(product, index) in ProFilterList" :key="product.ProNo" class="index-item">
                        {{ index + 1 }}.
                      </div>
                    </div>
                    <div style="flex-grow: 1">
                      <draggable v-model="ProFilterList" @end="onEnd">
                        <div
                          v-for="(product, index) in ProFilterList"
                          :key="product.ProNo"
                          class="product-item shadow-sm"
                        >
                          {{ product.ProName }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>

                <div class="modal-footer">
                  <div class="d-flex">
                    <div class="mr-2">
                      <button type="button" class="btn btn-primary" @click.prevent="SaveProSort">儲存</button>
                    </div>
                    <div>
                      <button type="button" class="btn btn-secondary" @click.prevent="CloseProNoModal">關閉</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'
  import draggable from 'vuedraggable'

  export default {
    components: {
      draggable,
    },
    metaInfo() {
      return {
        title: '參展產品 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        CSRF_Token: '',
        RegNo: '',
        ProductAmount: '',
        ProductData: {},
        companyName: '',
        ecompanyName: '',
        SelectCat: '',
        ProductCategory: [],
        BoothNo: '',

        currentPage: 2,
        totalPage: '',
        totalNo: '',
        ProductRawData: [],
        ProductList: [],
        totaltenPageNum: 0,
        tenPageNum: 0,
        showpage: [],
        lang: 'tw',
        logoImg: '',

        //判斷各頁狀態儀表版值
        OnlineExpolayoutStatus: '',
        PressReleaseStatus: '',
        VideoStatus: '',
        ProductStatus: '',
        BasicinformationStatus: '',

        //判斷儀表板是否有線上展
        HasOnlineExpo: '',
        openOnlineExpo: '',
        showOnlineStatus: false,
        eventId: '',
        hasHistoryPro: false,
        // check1: false,
        // isTeam: '',

        getArch: '',

        messages: [],

        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',

        ProFilterList: [],
      }
    },
    methods: {
      SaveProSort() {
        $('#openProNoModal').modal('hide')
        // window.location.reload()

        const vm = this

        let info = {
          ProductSortList: vm.ProFilterList,
          CSRF: vm.CSRF_Token,
        }

        const url = `/apiExhibitors/Product/ChangeProductSort/${vm.RegNo}`
        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            alert('您已成功修改產品排序！')

            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}&Page=1`
          } else if (response.data.Code == 253) {
            alert('產品序號錯誤！')
          } else if (response.data.Code == 252) {
            alert('CSRF驗證失敗')
          } else {
            alert('系統忙線中，請稍後再試！')
          }
        })
      },

      openProNo() {
        const vm = this

        //取得產品列表
        let url = `https://www.chanchao.com.tw/apiExhibitors/Product/${vm.RegNo}?mode=more&Page=`

        axios.get(url).then(function (response) {
          if (response.data.Code == 200) {
            // console.log(response)
            let GetProFilterList = response.data.Data

            vm.ProFilterList = GetProFilterList.map((item) => {
              return {
                ProName: item.ProName,
                ProNo: item.ProNo,
              }
            })

            $('#openProNoModal').modal('show')
          } else if (response.data.Code == 404) {
          }
        })
      },

      CloseProNoModal() {
        const vm = this
        $('#openProNoModal').on('hide.bs.modal', function () {
          vm.ModalData = []
        })
        $('#openProNoModal').modal('hide')
      },

      onEnd(event) {},
      updateMessage(message, status) {
        const timestamp = Math.floor(new Date() / 1000)
        this.messages.push({
          message,
          status,
          timestamp,
        })
        this.removeMessageWithTiming(timestamp)
      },
      removeMessage(num) {
        this.messages.splice(num, 1)
      },
      removeMessageWithTiming(timestamp) {
        const vm = this
        setTimeout(() => {
          vm.messages.forEach((item, i) => {
            if (item.timestamp === timestamp) {
              vm.messages.splice(i, 1)
            }
          })
        }, 1500)
      },

      getPage(page) {
        const vm = this

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}&Page=${page}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}&Page=${page}`
        }
      },

      nextPage() {
        const vm = this
        let nextP = Number(vm.currentPage) + 1

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}&Page=${nextP}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}&Page=${nextP}`
        }
      },

      lastPage() {
        const vm = this
        let lastP = Number(vm.currentPage) - 1
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}&Page=${lastP}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}&Page=${lastP}`
        }
      },

      nexttenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum + 1
        vm.showpage = vm.inquiryRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}&Page=${vm.currentPage}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}&Page=${vm.currentPage}`
        }
      },

      returntenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum - 1
        vm.showpage = vm.inquiryRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}&Page=${vm.currentPage}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}&Page=${vm.currentPage}`
        }
      },

      ProductModal(id) {
        const vm = this

        let url = `/apiExhibitors/Product/${vm.RegNo}/${id}`
        axios.get(url).then(function (response) {
          // console.log(response.data)
          vm.ProductData = response.data.Data

          //核對產品類別，取得已選的類別

          if (vm.ProductData.CatNo) {
            vm.SelectCat = vm.ProductCategory.find((item) => {
              return item.CatNo == vm.ProductData.CatNo
            })
          } else {
            vm.SelectCat = ''
          }
        })

        if (vm.lang == 'tw') {
          $('#openModal a[href="#nav-home"]').tab('show')
          $('#openModal').modal('show')
        } else {
          $('#openModal a[href="#nav-profile"]').tab('show')
          $('#openModal').modal('show')
        }
      },

      toProductAdd() {
        const vm = this
        if (vm.ProductAmount > vm.totalNo) {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/productAdd?no=${vm.RegNo}`
        } else {
          alert('您已無新增產品額度，如需發佈更多產品，請至加值服務方案查看升級辦法。')
        }
      },

      toEnProductAdd() {
        const vm = this
        if (vm.ProductAmount > vm.totalNo) {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/productAdd?no=${vm.RegNo}`
        } else {
          alert(
            'You have reached the limit of amount of products. If you need to publish more products, please check Paid Services.'
          )
        }
      },

      toEditProduct(id) {
        const vm = this
        // console.log($(window).scrollTop())

        if (vm.currentPage == 1) {
          sessionStorage.setItem('scrollHeight', $(window).scrollTop())
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/productEdit?no=${vm.RegNo}&id=${id}`
        } else {
          sessionStorage.setItem('scrollHeight', $(window).scrollTop())
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/productEdit?no=${vm.RegNo}&id=${id}&Page=${vm.currentPage}`
        }
      },

      toEnEditProduct(id) {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/productEdit?no=${vm.RegNo}&id=${id}`
      },

      delProduct(id) {
        const vm = this

        if (vm.lang == 'tw') {
          if (confirm('請確認要刪除此項產品嗎？')) {
            const info = {
              CSRF: vm.CSRF_Token,
            }

            const url = `/apiExhibitors/Product/${vm.RegNo}?ProNo=${id}`

            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                // alert('您選擇的產品已刪除成功！')
                // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`

                vm.updateMessage(`您已刪除所選產品`, 'warning')
                vm.getProduct('Del')
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          } else {
            return false
          }
        } else {
          if (confirm('Delete this product? ')) {
            const info = {
              CSRF: vm.CSRF_Token,
            }

            const url = `/apiExhibitors/Product/${vm.RegNo}?ProNo=${id}`

            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                vm.updateMessage(`Product successfully deleted !`, 'warning')

                vm.getProduct('Del')
              } else if (response.data.Code == 251) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              } else if (response.data.Code == 500) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`
              }
            })
          } else {
            return false
          }
        }
      },

      toRegisterProduct(id) {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionAdd?no=${vm.RegNo}&id=${id}&eventId=${vm.eventId}`
      },

      toHistoryExhibitors() {
        const vm = this

        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/productHistoryExh?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/productHistoryExh?no=${vm.RegNo}`
        }
      },

      switchButtom(ProNo, Archived, ProName) {
        const vm = this

        if (Archived == 1) {
          let info = {
            Archived: 0,
            CSRF: vm.CSRF_Token,
          }

          const url = `/apiExhibitors/ProductArchived/${ProNo}`
          axios.post(url, info).then(function (response) {
            // console.log(response.data)

            if (response.data.Code == 200) {
              vm.updateMessage('已修改為顯示狀態', 'warning')

              vm.getProduct('Switch')
            } else if (response.data.Code == 253) {
              alert('產品序號錯誤！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else {
              alert('系統忙線中，請稍後再試！')
            }
          })
        } else if (Archived == 0) {
          const info = {
            Archived: 1,
            CSRF: vm.CSRF_Token,
          }
          const url = `/apiExhibitors/ProductArchived/${ProNo}`
          axios.post(url, info).then(function (response) {
            // console.log(response.data)

            if (response.data.Code == 200) {
              vm.updateMessage('已修改為隱藏狀態', 'warning')

              vm.getProduct('Switch')
            } else if (response.data.Code == 253) {
              alert('產品序號錯誤！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else {
              alert('系統忙線中，請稍後再試！')
            }
          })
        }
      },

      switchButtomEn(ProNo, Archived, ProName) {
        const vm = this

        if (Archived == 1) {
          let info = {
            Archived: 0,
            CSRF: vm.CSRF_Token,
          }

          const url = `/apiExhibitors/ProductArchived/${ProNo}`

          axios.post(url, info).then(function (response) {
            // console.log(response.data)

            if (response.data.Code == 200) {
              vm.updateMessage('successfully shown', 'warning')

              vm.getProduct('Switch')
            } else if (response.data.Code == 253) {
              alert('ProductNo Error！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else {
              alert('System is busy, please try again later.')
            }
          })
        } else if (Archived == 0) {
          const info = {
            Archived: 1,
            CSRF: vm.CSRF_Token,
          }
          const url = `/apiExhibitors/ProductArchived/${ProNo}`
          axios.post(url, info).then(function (response) {
            // console.log(response.data)

            if (response.data.Code == 200) {
              vm.updateMessage('successfully hidden', 'warning')

              vm.getProduct('Switch')
            } else if (response.data.Code == 253) {
              alert('ProductNo Error！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else {
              alert('System is busy, please try again later.')
            }
          })
        }
      },

      getProduct(Stats) {
        const vm = this

        //取得產品列表
        let url = `https://www.chanchao.com.tw/apiExhibitors/Product/${vm.RegNo}?mode=page&Page=${vm.currentPage}`

        axios.get(url).then(function (response) {
          if (response.data.Code == 200) {
            // console.log(response)

            vm.totalNo = response.data.datatotal

            vm.ProductList = response.data.Data
            vm.totalPage = response.data.pagetotal

            if (Stats == 'Del') {
              if (vm.currentPage <= vm.totalPage) {
              } else {
                if (vm.lang == 'tw') {
                  document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}&Page=${vm.totalPage}`
                } else {
                  document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}&Page=${vm.totalPage}`
                }
              }
            }
          } else if (response.data.Code == 404) {
            window.location.reload()
          }
        })
      },
    },

    created() {
      const vm = this

      setTimeout(() => {
        let getscrollHeight = sessionStorage.getItem('scrollHeight')
        if (getscrollHeight) {
          window.scrollTo(0, getscrollHeight)
          sessionStorage.removeItem('scrollHeight')
        }
      }, 200)

      //取得語系

      $(() => {
        $('#SliderTop').click(() => {
          $('html,body').animate({ scrollTop: 0 }, 'slow')
          return false
        })

        $(window)
          .scroll(function () {
            if ($(this).scrollTop() > 300) {
              $('#SliderTop').fadeIn(222)
            } else {
              $('#SliderTop').stop().fadeOut(222)
            }
          })
          .scroll()
      })

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href

      //取得RegNo
      vm.RegNo = currentUrl.split('no=')[1].split('&')[0]

      if (currentUrl.split('eventId=')[1]) {
        vm.eventId = currentUrl.split('eventId=')[1].split('&')[0]
      }

      // vm.eventId = currentUrl.split('eventId=')[1].split('&')[0]

      let hasPagenum = new URL(currentUrl)
      vm.currentPage = hasPagenum.searchParams.get('Page')

      if (!vm.currentPage) {
        vm.currentPage = 1
      }

      // 取得產品額度
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        vm.ProductAmount = response.data.Data.ProductAmount
        vm.companyName = response.data.Data.Company
        vm.ecompanyName = response.data.Data.eCompany
        vm.BoothNo = response.data.Data.BoothNo

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus
        vm.VideoStatus = response.data.Data.VideoStatus
        vm.ProductStatus = response.data.Data.ProductStatus
        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus

        vm.HasOnlineExpo = response.data.Data.Virtual

        //取得是否開啟線上展權限
        axios
          .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`)
          .then((response) => {
            // console.log(response.data)

            vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
            vm.ExhBegin = response.data.Data.ExhBegin
            vm.ExhEnd = response.data.Data.ExhEnd
            vm.ExhVenue = response.data.Data.ExhVenue
            vm.eExhVenue = response.data.Data.eExhVenue

            vm.logoImg = response.data.Data.ExhLogo

            vm.openOnlineExpo = response.data.Data.OnlineExpo_Archived

            if (vm.openOnlineExpo == 1 && vm.HasOnlineExpo == 1) {
              vm.showOnlineStatus = true
            } else {
              vm.showOnlineStatus = false
            }
          })
      })

      //取得產品列表
      let url = `https://www.chanchao.com.tw/apiExhibitors/Product/${vm.RegNo}?mode=page&Page=${vm.currentPage}`

      axios.get(url).then(function (response) {
        if (response.data.Code == 200) {
          // console.log(response)
          vm.totalNo = response.data.datatotal

          if (response.data.pagetotal > 0) {
            vm.ProductList = response.data.Data

            vm.totalPage = response.data.pagetotal

            if (vm.currentPage <= vm.totalPage) {
            } else {
              if (vm.lang == 'tw') {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
              } else {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`
              }
            }

            for (let i = 0; i < vm.totalPage; i++) {
              if (i % 10 === 0) {
                vm.ProductRawData.push([])
              }

              const page = parseInt(i / 10) //取parseInt整數
              vm.ProductRawData[page].push(i + 1)
            }

            //totaltenPageNum 取得共有幾筆十頁
            vm.totaltenPageNum = vm.ProductRawData.length
            //從取得的筆數後，tenNum 計算出現第幾個十頁數

            let anaNowPage = vm.currentPage - 1 //判定第幾頁(十頁)，頁數減一避免進位

            vm.tenPageNum = parseInt(anaNowPage / 10)
            vm.showpage = vm.ProductRawData[vm.tenPageNum]

            //取得產品類別
            let url2 = `/apiExhibitors/ProductCategory/${vm.RegNo}`
            axios.get(url2).then(function (response) {
              vm.ProductCategory = response.data.Data
            })
          } else {
            if (vm.currentPage > 1) {
              if (vm.lang == 'tw') {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
              } else {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`
              }
            }
          }
        } else if (response.data.Code == 404) {
          vm.totalNo = 0
          vm.totalPage = 0
        }
      })

      //是否有歷年產品紀錄

      let url2 = `https://www.chanchao.com.tw/apiExhibitors/Product/PreviousRegister?RegNo=${vm.RegNo}&lang=${vm.lang}`

      axios.get(url2).then(function (response) {
        if (response.data.datatotal) {
          vm.hasHistoryPro = true
        } else {
          vm.hasHistoryPro = false
        }
      })
    },
  }
</script>

<style lang="scss">
  .NumberStyle {
    width: 30px;
    height: 30px;
    border-radius: 999em;
    background-color: #e6e5e5;
    font-size: 14px;
    font-weight: 700;
  }

  .card-footer {
    padding: 0.1rem 0.2rem;
    background-color: rgb(255 255 255 / 3%);
    border-top: 1px solid rgba(0, 0, 0, 0.125);
  }

  .uncomplete {
    background-image: url('../../../assets/images/tickGray.svg');
    width: 18px;
    height: 18px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: auto 100%;
    padding-left: 20px;
  }

  .complete {
    background-image: url('../../../assets/images/tick.svg');
    width: 18px;
    height: 18px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: auto 100%;
    padding-left: 20px;
  }

  .btn-outline-primary:hover {
    color: #1d49e7;
    /* background-color: #007bff; */
    /* border-color: #007bff; */
    background-color: #007bff00;
  }

  .message-alert {
    position: fixed;
    max-width: 75%;
    top: 100px;
    right: 20px;
    z-index: 1100;
  }

  .animate__animated {
    --animate-duration: 0.5s;
  }

  .alertM {
    padding: 15px 20px;
    font-size: 14px;
    border-radius: 5px;
    margin-top: 7px;
  }

  .Pro_draggable {
    display: flex;
    align-items: center;
    width: 100%; /* 確保容器不超出螢幕寬度 */
    flex-wrap: nowrap; /* 禁止換行，讓序號和名稱保持在同一行 */
  }
  .index-item {
    width: 34px; /* 固定寬度讓序號不會變形 */
    text-align: center;
    margin-right: 10px;
    border: 1px solid #ffffff; /* 添加邊框 */
    margin-bottom: 7px;
  }

  .product-item {
    white-space: nowrap; /* 防止名稱換行 */
    overflow: hidden;
    text-overflow: ellipsis; /* 如果名稱太長，顯示省略號 */
    cursor: move;
    flex-grow: 1; /* 讓名稱區域自動佔滿剩餘空間 */
    max-width: 100%; /* 保證名稱不會超過父容器 */
    box-sizing: border-box; /* 讓 padding 和 border 包含在寬度內 */
    border: 1px solid #0046ff52; /* 添加邊框 */
    background-color: #dfe9f663;
    padding: 0px 5px;
    margin-bottom: 7px;
  }

  .modal-body {
    overflow-y: scroll;
    max-height: 80vh;
  }

  .modal-header {
    background-color: #eeecec;
  }
</style>
